<div class="doc-identity">
  <div
    class="doc-identity__icon"
    [class.doc-identity__icon--uploading]="iconState === 'uploading'"
    [class.doc-identity__icon--archive]="iconState === 'archive'"
    [class.doc-identity__icon--extracting]="iconState === 'extracting'"
    [class.doc-identity__icon--categorizing]="iconState === 'categorizing'"
    [class.doc-identity__icon--indexing]="iconState === 'indexing'"
    [class.doc-identity__icon--just-categorized]="iconState === 'just-categorized'"
    [class.doc-identity__icon--uncategorized]="iconState === 'default' && isUncategorized"
    [style.color]="iconState === 'default' && !isUncategorized && subtypeName ? color : null"
    [style.background-color]="iconState === 'default' && !isUncategorized && subtypeName ? color + '1F' : null"
    aria-hidden="true"
  >
    @if (iconState === 'extracting') {
      <span class="doc-identity__spinner doc-identity__spinner--violet"></span>
    } @else if (iconState === 'categorizing') {
      <span class="doc-identity__spinner doc-identity__spinner--amber"></span>
    } @else if (iconState === 'indexing') {
      <span class="doc-identity__spinner doc-identity__spinner--info"></span>
    } @else if (iconState === 'just-categorized') {
      <i class="ph ph-check"></i>
    } @else if (iconState === 'archive') {
      <i class="ph ph-archive"></i>
    } @else {
      <i class="ph ph-file-text"></i>
    }
  </div>
  <div class="doc-identity__body">
    <p class="doc-identity__name">
      <span
        class="doc-identity__name-text"
        [ngbTooltip]="name"
        tooltipClass="simple-tooltip"
        overflowTooltip
        [openDelay]="500"
        placement="bottom-start"
        >{{ name }}</span
      >
    </p>
    @if (showMeta) {
      <div class="doc-identity__meta">
        @if (processingStep === DocumentProcessingStepEnum.UPLOADING) {
          <div
            class="doc-identity__progress"
            role="progressbar"
            [attr.aria-valuenow]="uploadProgress ?? 0"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div class="doc-identity__progress-bar" [style.width.%]="uploadProgress ?? 0"></div>
          </div>
        } @else if (processingStep === DocumentProcessingStepEnum.EXTRACTING) {
          <span class="doc-identity__status doc-identity__status--extracting">
            {{ 'tenders.responses.documents.extraction-in-progress' | translate }}
          </span>
        } @else if (processingStep === DocumentProcessingStepEnum.CATEGORIZING) {
          <span class="doc-identity__status doc-identity__status--categorizing">
            {{ 'tenders.responses.documents.categorization-in-progress' | translate }}
          </span>
        } @else if (processingStep === DocumentProcessingStepEnum.INDEXING) {
          <span class="doc-identity__status doc-identity__status--indexing">
            {{ 'tenders.responses.documents.indexation-in-progress' | translate }}
          </span>
        } @else {
          @if (
            isUncategorized ||
            metaVariant === 'library' ||
            fileSizeKey ||
            (usedCount != null && usedCount > 0) ||
            uploaderName ||
            formattedDate ||
            inLibraryLabel ||
            addToLibraryLabel ||
            libraryChecking
          ) {
            <span class="doc-identity__meta-text">
              @if (metaVariant === 'library') {
                @if (usedCount != null && usedCount > 0) {
                  <span>{{ 'tenders.library.used-count' | translate: { count: usedCount } }}</span>
                }
                @if (uploaderName) {
                  @if (usedCount != null && usedCount > 0) {
                    <span aria-hidden="true"> · </span>
                  }
                  <span>{{ uploaderName }}</span>
                }
                @if (formattedDate) {
                  @if ((usedCount != null && usedCount > 0) || uploaderName) {
                    <span aria-hidden="true"> · </span>
                  }
                  <span>{{ formattedDate }}</span>
                }
                @if (isUncategorized) {
                  @if ((usedCount != null && usedCount > 0) || uploaderName || formattedDate) {
                    <span aria-hidden="true"> · </span>
                  }
                  <span class="doc-identity__uncat">{{ 'tenders.responses.documents.to-categorize' | translate }}</span>
                }
              } @else {
                @if (fileSizeKey) {
                  <span>{{ fileSizeKey | translate: { size: fileSizeParam } }}</span>
                }
                @if (isUncategorized) {
                  @if (fileSizeKey) {
                    <span aria-hidden="true"> · </span>
                  }
                  <span class="doc-identity__uncat">{{ 'tenders.responses.documents.to-categorize' | translate }}</span>
                }
                @if (usedCount != null && usedCount > 0) {
                  @if (fileSizeKey || isUncategorized) {
                    <span aria-hidden="true"> · </span>
                  }
                  <span>{{ 'tenders.responses.documents.dedup.used-count' | translate: { count: usedCount } }}</span>
                }
                @if (uploaderName) {
                  @if (fileSizeKey || isUncategorized || (usedCount != null && usedCount > 0)) {
                    <span aria-hidden="true"> · </span>
                  }
                  <span>{{ uploaderName }}</span>
                }
                @if (formattedDate) {
                  @if (fileSizeKey || isUncategorized || (usedCount != null && usedCount > 0) || uploaderName) {
                    <span aria-hidden="true"> · </span>
                  }
                  <span>{{ 'tenders.library.added-on' | translate: { date: formattedDate } }}</span>
                }
                @if (libraryChecking) {
                  @if (fileSizeKey || isUncategorized || (usedCount != null && usedCount > 0) || uploaderName || formattedDate) {
                    <span aria-hidden="true"> · </span>
                  }
                  <span class="doc-identity__checking">
                    <span class="doc-identity__spinner" aria-hidden="true"></span>
                    {{ libraryCheckingLabel }}
                  </span>
                } @else if (inLibraryLabel) {
                  @if (fileSizeKey || isUncategorized || (usedCount != null && usedCount > 0) || uploaderName || formattedDate) {
                    <span aria-hidden="true"> · </span>
                  }
                  <span>{{ inLibraryLabel }}</span>
                } @else if (addToLibraryLabel) {
                  @if (fileSizeKey || isUncategorized || (usedCount != null && usedCount > 0) || uploaderName || formattedDate) {
                    <span aria-hidden="true"> · </span>
                  }
                  <button type="button" class="doc-identity__lib-link" (click)="libraryAction.emit(); $event.stopPropagation()">
                    {{ addToLibraryLabel }}
                  </button>
                }
              }
            </span>
          }
        }
      </div>
    }
  </div>
</div>
